import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalForms`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetFormsList' },
  { name: 'GetFormsOrders' },
  { name: 'GetFormsOrder' },
  { name: 'GetDefaultAddress' },
  { name: 'UpdateAddress' },
  { name: 'CreateFormsOrder' },
  { name: 'CancelFormsOrder' },
  { name: 'EmailForm' },
  { name: 'GetFormStatusList' },
  { name: 'UpdateFormsOrderStatus' },
  { name: 'GetFormsByUserID' },
  { name: 'GetFormsByIDs' },
  { name: 'GetFormsForMarketingCMS' },
]);

const GetFormsList = () => api.endpoints.GetFormsList.post();
const GetFormsOrders = () => api.endpoints.GetFormsOrders.post();
const GetFormsOrder = (body) => api.endpoints.GetFormsOrder.post(body);
const GetDefaultAddress = () => api.endpoints.GetDefaultAddress.post();
const UpdateAddress = (body) => api.endpoints.UpdateAddress.post(body);
const CreateFormsOrder = (body) => api.endpoints.CreateFormsOrder.post(body);
const CancelFormsOrder = (body) => api.endpoints.CancelFormsOrder.post(body);
const EmailForm = (body) => api.endpoints.EmailForm.post(body);
const GetFormStatusList = () => api.endpoints.GetFormStatusList.post();
const UpdateFormsOrderStatus = (body) => api.endpoints.UpdateFormsOrderStatus.post(body);
const GetFormsByUserID = () => api.endpoints.GetFormsByUserID.post();
const GetFormsByIDs = (formIDs) =>
  api.endpoints.GetFormsByIDs.postMultipleQueryString([
    {
      queryParam: 'formIDs',
      queryVal: formIDs,
    },
  ]);
const GetFormsForMarketingCMS = (maxResults, searchQuery) =>
  api.endpoints.GetFormsForMarketingCMS.postMultipleQueryString([
    {
      queryParam: 'maxResults',
      queryVal: maxResults,
    },
    {
      queryParam: 'searchQuery',
      queryVal: searchQuery,
    },
  ]);

export {
  GetFormsList,
  GetFormsOrders,
  GetFormsOrder,
  GetDefaultAddress,
  UpdateAddress,
  CreateFormsOrder,
  CancelFormsOrder,
  EmailForm,
  GetFormStatusList,
  UpdateFormsOrderStatus,
  GetFormsByUserID,
  GetFormsByIDs,
  GetFormsForMarketingCMS,
};
